const parseEntity = (data: any) => {
    return data && data[0] ? data[0] : null;
};

export default parseEntity;
